import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CircularsPage } from './circulars';

@NgModule({
  declarations: [
    CircularsPage,
  ],
  imports: [
    IonicPageModule.forChild(CircularsPage),
  ],
})
export class CircularsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/circulars/circulars.module.ts